import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// INTERFACES

// SERVICES
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';
@Injectable({
  providedIn: 'root',
})
export class AppIntegrationAccountProductsApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/products`,
      { params },
    );
  }

  update(id :number, data :any) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/app-integration-accounts/products/${id}`,
      data,
    );
  }

  syncProducts(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/sync-products`,
      { params },
    );
  }

  autoMapProducts(appIntegrationAccountId :number) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/${appIntegrationAccountId}/map-product-skus`,
    );
  }

  autoCreateUnmappedProducts(data :{
    appIntegrationAccountId :number;
    productIds ?:number[];
    defaultValues ?:{
      category_id :number;
      subcategory_id :number;
    };
    enableJobStatusTracking ?:boolean;
  }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/app-integration-accounts/products/auto-create-unmapped`,
      body: data,
    });
  }
}
